import { Menu } from "antd";
import * as React from "react";
import cx from "classnames";
import { BadgeIcon, Icon } from "../icon";

import horizontalMenuCss from "./horizontal-menu.css";
import { IBaseMenuItemProps, IMenuItem } from "./menu-item";
import { ItemType } from "antd/lib/menu/hooks/useItems";

export interface IHorizontalMenuProps extends IBaseMenuItemProps {
    selectedKeys?: string[];
    className?: string;
}

const buildMenuItem = (menuItem: IMenuItem, defaultClassName?: string): ItemType => {
    const hasChildren = Array.isArray(menuItem.subMenuItems) && menuItem.subMenuItems.length > 0;

    return {
        key: menuItem.code,
        label: menuItem.label ? menuItem.label(menuItem) : undefined,
        className: menuItem.badge
            ? undefined
            : hasChildren
              ? cx(defaultClassName, horizontalMenuCss.menuItem)
              : horizontalMenuCss.subMenuItem,
        icon: <IconMenuItem menuItem={menuItem} />,
        ...(hasChildren
            ? {
                  onTitleClick: () => menuItem.onClick?.(menuItem),
                  children: menuItem.subMenuItems?.map((subMenuItem) => buildMenuItem(subMenuItem, defaultClassName)),
              }
            : {
                  onClick: () => menuItem.onClick?.(menuItem),
              }),
    };
};
    const IconMenuItem = (props: { menuItem: IMenuItem }) => {
        const { menuItem } = props;
        const iconSize = menuItem.iconSize || (menuItem.label ? 'SMALL' : 'REGULAR');
        return menuItem.badge ? (
            <BadgeIcon
                className={horizontalMenuCss['icon-wrapper']}
                iconClassName={horizontalMenuCss['badge-icon']}
                iconName={menuItem.iconName}
                size={iconSize}
                asPrefix
                badge={{ ...menuItem.badge }}
            />
        ) : (
            <Icon
                className={horizontalMenuCss['icon-wrapper']}
                iconName={menuItem.iconName}
                size={iconSize}
                asPrefix
            />
        );
    };
export function HorizontalMenu(props: IHorizontalMenuProps) {

    const listOfMenuItems = props.menuItems.map(menuItem => buildMenuItem(menuItem, props.className));

    return (
      <Menu mode="horizontal" className={horizontalMenuCss.horizontalMenu} hidden={props.hidden} selectedKeys={props.selectedKeys} items={listOfMenuItems} />
    );
}
